import React from "react";
import { useTranslation } from "react-i18next";
import AvoirCard from "./AvoirCard";
import AvoirSummary from "./AvoirSummary";
import { isDefined } from "../../Utils";

const Avoir = ({ id, formData, setFormData, isParticulier }) => {
  const { t } = useTranslation("common");
  const handleChange = (e, index) => {
    const { name, value } = e.target;
    if (name === "packings") {
      setFormData((prev) => {
        const updatedFormData = { ...prev };
        if (updatedFormData?.total[index]) {
          if (isParticulier) {
            updatedFormData.total[index].totalHT = value ?? 0;
          } else {
            updatedFormData.total[index].totalHT = value ?? 0;
          }
        }
        return updatedFormData;
      });
    } else if (name === "delivery") {
      setFormData((prev) => ({ ...prev, [name]: value ?? 0 }));
    }
  };

  const deleteGroup = (index) => {
    setFormData((prev) => {
      const updatedFormData = { ...prev };
      const deletedAvoirPackings = prev?.deletedAvoirPackings ?? [];

      if (
        updatedFormData &&
        updatedFormData?.packings[index][0]?.attributes?.avoirPacking?.data
      ) {
        deletedAvoirPackings.push({
          ...updatedFormData?.packings[index][0]?.attributes?.avoirPacking
            ?.data,
          packingId: updatedFormData?.packings[index][0]?.id,
        });
      }

      updatedFormData.total.splice(index, 1);
      updatedFormData.packings.splice(index, 1);
      return { ...updatedFormData, deletedAvoirPackings };
    });
  };

  const deleteDelivery = () => {
    setFormData((prev) => ({ ...prev, delivery: null }));
  };

  return (
    <div className="flex-grow-1">
      <p className="text-decoration-underline mb-4 text-dark f24">
        {t("Credit Creation")}
      </p>
      <div className="d-flex flex-column gap-4">
        {formData?.packings?.map(
          (group, index) =>
            group?.length > 0 && (
              <AvoirCard
                isParticulier={isParticulier}
                data={group}
                totalHT={formData?.total[index]?.totalHT}
                handleChange={(e) => handleChange(e, index)}
                handleDelete={() => deleteGroup(index)}
              />
            )
        )}
        {isDefined(formData?.delivery) && (
          <AvoirCard
            isDelivery
            data={formData}
            handleChange={handleChange}
            handleDelete={deleteDelivery}
          />
        )}
        <AvoirSummary id={id} data={formData} isParticulier={isParticulier} />
      </div>
    </div>
  );
};

export default Avoir;
